"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMediafileLastPlaytime = exports.setFileCacheState = exports.removeMediafileCache = exports.removeMediafile = exports.addMediafiles = void 0;
var types_1 = require("../types");
var lodash_uniqby_1 = __importDefault(require("lodash.uniqby"));
var Mediafiles_1 = __importDefault(require("../services/Mediafiles"));
var initialState = {};
function addMediafiles() {
    var mediafiles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        mediafiles[_i] = arguments[_i];
    }
    return {
        type: addMediafiles.type,
        payload: {
            mediafiles: mediafiles,
        },
    };
}
exports.addMediafiles = addMediafiles;
addMediafiles.type = "mediafiles/add";
function removeMediafile(mediafileId) {
    return {
        type: removeMediafile.type,
        payload: {
            mediafileId: mediafileId,
        },
    };
}
exports.removeMediafile = removeMediafile;
removeMediafile.type = "mediafiles/remove";
function removeMediafileCache(id, filename) {
    return {
        type: removeMediafileCache.type,
        payload: {
            id: id,
            filename: filename,
        },
    };
}
exports.removeMediafileCache = removeMediafileCache;
removeMediafileCache.type = "mediafiles/removeMediafileCache";
function setFileCacheState(mediafileId, filename, state) {
    return {
        type: setFileCacheState.type,
        payload: {
            mediafileId: mediafileId,
            filename: filename,
            state: state,
        },
    };
}
exports.setFileCacheState = setFileCacheState;
setFileCacheState.type = "mediafiles/setFileCacheState";
function updateMediafileLastPlaytime(id, filename) {
    return {
        type: updateMediafileLastPlaytime.type,
        payload: {
            id: id,
            filename: filename,
        },
    };
}
exports.updateMediafileLastPlaytime = updateMediafileLastPlaytime;
updateMediafileLastPlaytime.type = "mediafiles/updateLastPlaytime";
function mediafilesReducer(state, action) {
    var e_1, _a, _b, _c;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case addMediafiles.type:
            var mediafiles = (0, lodash_uniqby_1.default)(action.payload.mediafiles, "id");
            state = __assign({}, state);
            try {
                for (var mediafiles_1 = __values(mediafiles), mediafiles_1_1 = mediafiles_1.next(); !mediafiles_1_1.done; mediafiles_1_1 = mediafiles_1.next()) {
                    var mediafile_1 = mediafiles_1_1.value;
                    var alreadySavedMediafile = state[mediafile_1.id];
                    if (!alreadySavedMediafile) {
                        state[mediafile_1.id] = __assign(__assign({}, mediafile_1), { lastChange: {
                                reasons: ["new"],
                                changed: true,
                                timestamp: Date.now(),
                            } });
                        continue;
                    }
                    var merge = Mediafiles_1.default.mergeMediafiles(alreadySavedMediafile, mediafile_1);
                    state[mediafile_1.id] = __assign(__assign({}, merge.mediafile), { lastChange: {
                            reasons: merge.reasons,
                            changed: merge.changed,
                            timestamp: Date.now(),
                        } });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (mediafiles_1_1 && !mediafiles_1_1.done && (_a = mediafiles_1.return)) _a.call(mediafiles_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return state;
        case removeMediafile.type:
            state = __assign({}, state);
            return Object.fromEntries(Object.entries(state).filter(function (_a) {
                var _b = __read(_a, 2), key = _b[0], _ = _b[1];
                return String(key) !== String(action.payload.mediafileId);
            }));
        case setFileCacheState.type:
            var mediafile = state[action.payload.mediafileId];
            if (!mediafile) {
                return state;
            }
            var file = mediafile.files.find(function (item) { return item.filename === action.payload.filename; });
            var newFiles = file
                ? [__assign(__assign({}, file), { cacheState: action.payload.state })]
                : mediafile.files;
            return __assign(__assign({}, state), (_b = {}, _b[action.payload.mediafileId] = __assign(__assign({}, mediafile), { files: newFiles }), _b));
        case updateMediafileLastPlaytime.type:
            var mediafileToUpdate = state[action.payload.id];
            if (!mediafileToUpdate) {
                return state;
            }
            var updatedMediafile = __assign(__assign({}, mediafileToUpdate), { lastPlaytime: Date.now(), files: mediafileToUpdate.files.map(function (item) { return (__assign(__assign({}, item), { lastPlaytime: item.filename === action.payload.filename ? Date.now() : item.lastPlaytime })); }) });
            return __assign(__assign({}, state), (_c = {}, _c[action.payload.id] = updatedMediafile, _c));
        case removeMediafileCache.type:
            state = __assign({}, state);
            var mediafileToRemoveFileFrom = state[action.payload.id];
            if (!mediafileToRemoveFileFrom) {
                return state;
            }
            state[action.payload.id] = __assign(__assign({}, mediafileToRemoveFileFrom), { files: mediafileToRemoveFileFrom.files.map(function (item) { return (__assign(__assign({}, item), { cacheState: item.filename === action.payload.filename
                        ? types_1.EMediafileCacheState.NO_CACHE
                        : item.cacheState })); }) });
            return state;
        default:
            return state;
    }
}
exports.default = mediafilesReducer;
//# sourceMappingURL=mediafiles.js.map